export default __webpack_public_path__ + "static/media/scripting.e5648250.svg";